var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"clear-card attendanceCard",class:{
    detailsView: _vm.isDetailsView,
    listView: !_vm.isDetailsView,
    mobileMode: ['mobile', 'tablet'].includes(_vm.$mq),
    deskMode: ['desktop', 'laptop'].includes(_vm.$mq)
  },attrs:{"id":"attendanceCard","shadow":"hover","body-style":{
    padding: '0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  }}},[_c('div',{staticClass:"header defaultCursor",attrs:{"slot":"header"},slot:"header"},[(_vm.title !== 'Session Attendance')?_c('span',[_vm._v(_vm._s(_vm.title))]):_c('span',[_vm._v(_vm._s(_vm.$t('coach.leader.attendance.sessionAttendance')))])]),(_vm.formattedSession)?_c('div',{staticClass:"sessions",class:['mobile', 'tablet'].includes(_vm.$mq) ? 'mobileMode' : 'deskMode'},_vm._l((_vm.formattedSession),function(session,Skey){return _c('div',{key:Skey,staticClass:"session",class:[
        _vm.$mq,
        {
          disabledLink: session.status !== 'pending',
          disabledStatus: session.status === 'disabled',
        }
      ],on:{"click":function($event){return _vm.openAttendanceModal(session)}}},[_c('div',{staticClass:"status",class:{
          completed: session.status === 'completed',
          ongoing: session.status === 'pending',
          disabled: session.status === 'disabled',
          default: !['completed', 'pending', 'disabled'].includes(session.status),
        }}),_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.$t(("session." + (session.session_id))))+" ")])])}),0):_c('div',{staticClass:"noData"},[_vm._v(" "+_vm._s(_vm.$t('coach.leader.attendance.noData'))+" ")]),_c('AttendanceModal',{attrs:{"show":_vm.showAttendanceModal,"leader":_vm.leader,"session":_vm.sessionModal},on:{"update:show":function($event){_vm.showAttendanceModal=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }